<h1 mat-dialog-title translate>attention</h1>
<div mat-dialog-content>
    <p translate>
        are_you_over_18_years_old
    </p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="yes()">{{'yes_it_is_true' | translate}}</button>
    <button mat-button (click)="no()">{{'not_it_is_not_true' | translate}}</button>
</div>
